export default __webpack_public_path__ + "static/media/A4PosterRightCropped2.ad728a62.png";